import styled from 'styled-components';

const VideoPageHolder = styled.div`
	background-color: #ecf1f3;
	grid-area: content;
	overflow: auto;
	width: 100%;
	margin: 0 auto;

	.vp-content-title {
        font-family: "Quicksand", sans-serif;
        clear: both;
        font-weight: 700;
        line-height: 1.2;
        font-size: 24px;
        text-align: left;
        width: 100%;
        color: #fff;
        background-color: #726b55;
        padding: 12px;
		margin: 0;
		@media only screen and (max-width: 767px) {
			font-size: 20px;
			padding: 10px;
		}
    }
	.row {
        clear: both;
        display: flex;
        justify-content: space-around;
        flex-flow: row;
        align-items: stretch;
	}

	.content-wrapper-lspage {
		display: grid;
		grid-gap: 20px;
		grid-template-columns: 72% 25%;

		.wide {
			margin-right: 25px;
		}

		.content__right {
			float: right;
			max-width: 400px;
			width: 100%;
			margin: 0;
		}

		@media only screen and (max-width: 768px) {
			padding: 20px;
			grid-template-columns: 1fr;
		}

		@media only screen and (min-width: 768px) {
			margin: 0px;
			padding: 24px 0px 24px 24px;
		}
	}
	.jw-state-idle .jw-controls {
		background: transparent !important;
	}	

`;

export default VideoPageHolder;